import moment from 'moment'

import BaseInputDate from 'app/components/forms/base_inputDate/component'
import {
  firstElementOrEmptyString,
  withValidation,
} from 'app/components/forms/util'
import * as validations from 'app/shared_components/validations'
import * as helpers from 'app/sm/helpers'

// Export validators for testing
export const pastDateValidator = (date) =>
  validations.compareDates(
    date,
    moment().format(helpers.dateWithDash),
    'This field is required',
    'The date must be in the past',
  )

export const pastDateValidatorOptional = (date) => {
  // Empty date is valid (field is optional)
  if (!date || date === '') {
    return [] // No error for empty values
  }

  // Validate date format first using moment with strict parsing
  const momentDate = moment(date, helpers.dateWithDash, true)
  if (!momentDate.isValid()) {
    return ['Invalid date'] // Return format validation error
  }

  // If format is valid, check if it's in the past
  return validations.compareDates(
    date,
    moment().format(helpers.dateWithDash),
    'This field is required', // This will never show since we handle empty above
    'The date must be in the past',
  )
}

const validatePastDateFlattened = (date) =>
  firstElementOrEmptyString(pastDateValidator(date))

const validatePastDateOptionalFlattened = (date) =>
  firstElementOrEmptyString(pastDateValidatorOptional(date))

const InputPastDate = withValidation(BaseInputDate, validatePastDateFlattened)

export const InputPastDateOptional = withValidation(
  BaseInputDate,
  validatePastDateOptionalFlattened,
)

export default InputPastDate
